
export default {

    removeQuotes(data){
        return data.replaceAll('"', '');
    }

}